module.exports = __webpack_public_path__ + "img/ic_heart_on.7086e7bc.svg";